<template>
  <div class="wrapper">
    <img src="@/assets/brief/logo2.png" class="bg_class">
    <ul class="list_class">
      <router-link to="/HospitalProfile" tag="div">
        <li>
          <img src="@/assets/website/yyjs.png">
          <span>医院介绍</span>
        </li>
      </router-link>
      <router-link to="/YardBrief" tag="div">
        <li>
          <img src="@/assets/website/yqjs.png">
          <span>院区介绍</span>
        </li>
      </router-link>
      <router-link to="/NavigationSelectionYq?2" tag="div">
        <li>
          <img src="@/assets/website/ksjs.png">
          <span>科室介绍</span>
        </li>
      </router-link>
      <router-link to="/experts" tag="div">
        <li>
          <img src="@/assets/website/ysjs.png">
          <span>医生介绍</span>
        </li>
      </router-link>
      <router-link to="/HospitalNavigation" tag="div">
        <li>
          <img src="@/assets/website/ksfb.png">
          <span>科室分布</span>
        </li>
      </router-link>
      <router-link to="/NavigationSelectionYq?1" tag="div">
        <li>
          <img src="@/assets/website/lydh.png" style="width: 19px">
          <span>来院导航</span>
        </li>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { selectVisitinfos } from "@/request/api.js";
import { Base64 } from "js-base64";
export default {
  data() {
    return {
      user: {},
      bVisitinfoList: {}
    }
  },
  created() {
    if(sessionStorage.getItem("user") == null){
      let hspCode = window.location.href;
      let token = hspCode.split("?")[1];
      token = decodeURIComponent(token).replace(/\s/g, "+"); // decodeURIComponent() 对编码后的 URI 进行解码;
      console.log(token)
      let user = Base64.decode(token);
      this.user = JSON.parse(user);
      this.getLists();
      sessionStorage.setItem("user", user);
      sessionStorage.setItem("openid", this.user.userOpen.openid);
    }
  },
  methods: {
    async getLists() {
      let res = await selectVisitinfos({ openid: this.user.userOpen.openid });
      this.bVisitinfoList = res.data.obj;
      this.bVisitinfoList.forEach(item => {
        if (item.style == 1) {
          this.currentSel = item;
          sessionStorage.setItem("card", JSON.stringify(item));
        }
      });
      // if (this.bVisitinfoList.length == 0) {
      //   Dialog.alert({
      //     message: "无就诊卡请前往建卡页面"
      //   }).then(() => {
      //     this.$router.push("/AddVisitors");
      //   });
      // }
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #fdfdfd;
  .bg_class{
    width: 375px;
    height: 313px;
  }
  .list_class{
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    li{
      margin-top: 20px;
      width: 105px;
      height: 68px;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      background: #fff;
      border: 1px solid #e3f1ff;
      box-shadow: 0px 0px 4px .1px rgb(186, 219, 255);
      >img{
        width: 25px;
        height: 24px;
      }
      >span{
        margin-top: 6px;
        font-size: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/website.vue